var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("video-filter", {
        ref: "filter",
        attrs: { videos: _vm.videos, "pagination-data": _vm.paginationData },
        on: {
          "update:videos": function($event) {
            _vm.videos = $event
          },
          "update:paginationData": function($event) {
            _vm.paginationData = $event
          },
          "update:pagination-data": function($event) {
            _vm.paginationData = $event
          }
        }
      }),
      _vm._v(" "),
      _c("static-loading-indicator-icon"),
      _vm._v(" "),
      !_vm.$store.getters.shouldLoadLocal
        ? _c("div", { staticClass: "mt-3" }, [
            _vm.videos.length
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "alert alert-secondary border-dark" },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$t("pages.admin.video.select.explanation")
                          ) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row" },
                    _vm._l(_vm.videos, function(video) {
                      return _vm.videos.length
                        ? _c(
                            "div",
                            {
                              staticClass: "col-md-3 col-12 cursor-pointer",
                              on: {
                                dblclick: function($event) {
                                  return _vm.$emit("select", video.id)
                                }
                              }
                            },
                            [
                              _c("gym-video-card", {
                                key: video.id,
                                attrs: {
                                  video: video,
                                  "show-progress": false,
                                  "show-like": false,
                                  "show-completed": false,
                                  "hover-effect-enabled": false
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt-3" },
                    [
                      _c("pagination", {
                        attrs: { data: _vm.paginationData },
                        on: { "pagination-change-page": _vm.loadPage }
                      })
                    ],
                    1
                  )
                ])
              : _c(
                  "div",
                  { staticClass: "alert alert-secondary border-dark" },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("pages.admin.video.index.none_found")) +
                        "\n        "
                    )
                  ]
                )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }